// extracted by mini-css-extract-plugin
export default {"btn_group":"ButtonToggle_btn_group__C2eny","btn":"ButtonToggle_btn__BcLz4","active":"ButtonToggle_active__IbUJl","toggle_wrapper":"ButtonToggle_toggle_wrapper__+r7fH"};